import MyProcessPage from './myProcessPage.component';

export default MyProcessPage;